import { menuAction } from '../../../actions/menuActions';
import { isMenuItem, Item } from '@ael/core-api';
import { List } from 'immutable';

export interface SelectedMenuItemsReducerState {
  selectedItems: List<string>;
}

const emptyState = {
  selectedItems: List<string>(),
};

export function selectedMenuItemsReducer(
  state: SelectedMenuItemsReducerState = emptyState,
  action: any
): SelectedMenuItemsReducerState {
  switch (action.type) {
    case menuAction.SideMenu_DeselectItem: {
      const item = action.payload.selectedItem as Item;
      if (isMenuItem(item)) {
        let keep = true;
        return {
          ...state,
          selectedItems: state.selectedItems
            .filter((value: string) => {
              if (value === action.payload.selectedItem.id) {
                keep = false;
              }
              return keep;
            })
            .toList(),
        };
      }
      return {
        ...state,
      };
    }

    case menuAction.SideMenu_SelectedSubmenuItem: {
      if (!action.payload.parentItemId) {
        return {
          ...state,
          selectedItems: state.selectedItems.clear().push(action.payload.selectedItem.id),
        };
      }
      const lastSubmenuItem = state.selectedItems.last();
      // if the last opened menu item is the parent of the openning menu item
      if (lastSubmenuItem === action.payload.parentItemId) {
        return {
          ...state,
          selectedItems: state.selectedItems.push(action.payload.selectedItem.id),
        };
      }
      let keep = true;
      const newItemList = state.selectedItems
        .filter((value: string) => {
          if (value === action.payload.parentItemId) {
            keep = false;
            return true;
          }
          return keep;
        })
        .toList();
      return {
        ...state,
        selectedItems: newItemList.push(action.payload.selectedItem.id),
      };
    }
    case menuAction.SideMenu_ExpandSubmenu: {
      return { ...state, selectedItems: action.payload };
    }

    default:
      return state;
  }
}
